import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    FormControl,
    TextField,
    Paper,
    Button,
    IconButton,
    Tooltip,
    useTheme,
    LinearProgress,
    Select,
    MenuItem,
    InputLabel,
    Alert,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Breadcrumbs
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import * as Yup from "yup";
import {
    postData,
    getFetchData,
    requestMail,
    getLeaveentryData,
    getApprovallistData,
    PermissionApprovalVerify,
} from "../../store/reducers/Formapireducer";
import { Formik } from "formik";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";

import { LoadingButton } from "@mui/lab";
import { toast } from "react-hot-toast";
import { Productautocomplete } from "../../ui-components/global/Autocomplete";
import { dataGridHeaderFooterHeight, dataGridRowHeight, formGap } from "../../ui-components/global/utils";
import { leaveAppoval, mailNotify } from "../../store/reducers/Listviewapireducer";
import FileListPopup from "../../ui-components/FIleViewDialog";
import FileUploadIconButton from "../../ui-components/FileUploadButton";
import { attachmentPost, fetchApidata } from "../../store/reducers/LoginReducer";
import ViewListIcon from '@mui/icons-material/ViewList';
import GradingIcon from '@mui/icons-material/Grading';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import axios from "axios";
import { tokens } from "../../Theme";
import store from "../../index";
import { DataGrid } from "@mui/x-data-grid";
import { GridToolbarContainer } from "@mui/x-data-grid";
import { GridToolbarQuickFilter } from "@mui/x-data-grid";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import CryptoJS from "crypto-js";

const KEY = CryptoJS.enc.Utf8.parse("1234567890123456"); // 16-byte key
const IV = CryptoJS.enc.Utf8.parse("1234567890123456"); // 16-byte IV
function decryptDataUrlSafe(urlSafeBase64) {
    // Convert back to standard base64
    let base64 = urlSafeBase64.replace(/-/g, "+").replace(/_/g, "/");
    // Add padding if needed
    while (base64.length % 4 !== 0) {
        base64 += "=";
    }

    const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: CryptoJS.enc.Base64.parse(base64) },
        KEY,
        {
            iv: IV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        }
    );

    return decrypted.toString(CryptoJS.enc.Utf8);
}

const LeaveApproval = (empId, appId) => {
    const isNonMobile = useMediaQuery("(min-width:600px)");
    const navigate = useNavigate();
    const params = useParams();
    const location = useLocation();
    // const { toggleSidebar, broken, rtl } = useProSidebar();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const getLoading = useSelector((state) => state.formApi.getLoading);
    // const data = useSelector((state) => state.formApi.Data);
    const Data = useSelector((state) => state.formApi.Data);
    const ListData = useSelector((state) => state.formApi.approvalList);
    const listViewurl = useSelector((state) => state.globalurl.listViewurl);
    const header = useSelector((state) => state.formApi.Header);
    const isLoading = useSelector((state) => state.formApi.loading);
    const [loading, setLoading] = useState(false);
    const EMPID = sessionStorage.getItem("EmpId");
    const compID = sessionStorage.getItem("companyId");
    const dispatch = useDispatch();
    var recID = decryptDataUrlSafe(params.id);
    const mode = params.Mode;
    const accessID = params.accessID;
    const currentDate = new Date().toISOString().split("T")[0];
    const [selectedLeavetypebalance, setSelectedLeavetypebalance] = useState("");
    const [showtable, setShowtable] = useState(false);
    const [pageSize, setPageSize] = React.useState(10);
    const [error, setError] = useState('');
    const [open, setOpen] = useState(false);
    const [show, setScreen] = React.useState("0");
    const rowSx = { height: 36, '& td, & th': { py: 0.5 } };
    const exploreLoading = useSelector((state) => state.exploreApi.loading);
    // const approvallistdata = useSelector((state) =>stata.
    const [files, setFiles] = useState([]);
    const [showImage, setShowImage] = useState(params.Mode == "IM" ? true : false)
    useEffect(() => {
        dispatch(getFetchData({ accessID: "TR208", get: "get", recID })).then((res) => {
            console.log(res, "response");
            console.log(Data.EmployeeID, "response");
            var url = store.getState().globalurl.empGetAttachmentUrl;

            axios
                .get(url, {
                    params: {
                        empId: Data.EmployeeID,
                        appId: Data.RecordID,

                    }
                })
                .then((response) => {
                    setFiles(response.data);
                })
                .catch((err) => {
                    setError('Failed to fetch attachments.');
                    console.error(err);
                })
                .finally(() => setLoading(false));

        })
    }, []);
    const validationSchema = Yup.object().shape({
        leavetype: Yup.object()
            .nullable()
            .required("Leave Type is required"),
    });

    const screenChange = (event) => {
        setScreen(event.target.value);

        if (event.target.value == "1") {
            dispatch(getApprovallistData({ LeaveID: recID }));
        }

        if (event.target.value == "0") {
            dispatch(fetchApidata(accessID, "get", recID));
        }

    };


    const fnLogOut = (props) => {
        Swal.fire({
            title: `Do you want ${props}?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: props,
        }).then((result) => {
            if (result.isConfirmed) {
                if (props === "Logout") navigate("/");
                if (props === "Close") navigate(-1);
            }
        });
    };
    const Approvalinitialvalues = {
        applieddate: header?.AppliedDate || "",
        // leavetype: header?.LeaveTypeID
        //   ? { RecordID: header.LeaveTypeID, Name: header.LeaveType }
        //   : null,
        leavetype: header?.LeaveType || "",
        autoapproval: header?.AutoApprovals || "",
        autoreject: header?.AutoRejection || "",
    };
    // const leaveValidationSchema = Yup.object().shape({
    //   leavetype: Yup.object()
    // .nullable()
    // .required("Leave Type is required"),

    //   applieddate: Yup.string().required("Applied Date is required"),
    //   FromDate: Yup.string().required("From Date is required"),
    //   ToDate: Yup.string().required("To Date is required"),
    //   comments: Yup.string().required("Comments are required"),
    //   // add other fields as needed
    // });
    const leaveInitialValue = {
        applieddate: mode == "A" ? currentDate : Data.AppliedDate,
        RecordID: Data.RecordID,
        FromDate: Data.FromDate,
        ToDate: Data.ToDate,
        leavetype: Data.LeaveTypeID
            ? { RecordID: Data.LeaveTypeID, Name: Data.LeaveTypeName }
            : null,
        LeavePart: mode == "A" ? "N" : Data.LeavePart,
        BalanceDay: Data.BalanceDays,
        comments: Data.Comments,
        managerComments: Data.ManagerComments,
        Status: Data.Status,
        SortOrder: "1",
        Disable: "N",
    };

    const Balancedayfind = async (LeaveTypeID) => {
        try {
            const response = await dispatch(
                getLeaveentryData({
                    EmployeeID: EMPID,
                    LeaveTypeID: LeaveTypeID,
                })
            );

            console.log(response, "--find response lookup");

            const balancedayvaluefind = response.payload.Data;
            console.log(balancedayvaluefind, "--balancedayvaluefind");
            setSelectedLeavetypebalance(response.payload.Data.ELC_ELIGIBLEDAYS);
            console.log(selectedLeavetypebalance, "--selectedLeavetypebalance");

            // return balancedayvaluefind; // optional if needed
        } catch (error) {
            console.error("Error in Balancedayfind:", error);
        }
    };

    const leaveFNsave = async (values, resetForm, del) => {
        setLoading(true);
        let action =
            mode === "A" && !del
                ? "insert"
                : mode === "E" && del
                    ? "harddelete"
                    : "update";
        const idata = {
            RecordID: recID,
            FromDate: values.FromDate,
            ToDate: values.ToDate,
            LeavePart: values.LeavePart,
            Comments: values.comments,
            ManagerComments: values.managerComments,
            EmployeeID: mode == "M" ? params.parentID : EMPID,
            Status:
                mode == "A"
                    ? "AL"
                    : Data.Status == "QR" && values.Status == "QR"
                        ? "RA"
                        : values.Status,
            AppliedDate: values.applieddate,
            SortOrder: "1",
            Disable: "N",
            Source: "Self",
            LeaveTypeID: values.leavetype.RecordID || 0,
            LeaveTypeName: values.leavetype.Name || "",
            BalanceDay: selectedLeavetypebalance || values.BalanceDay,
            ApprovedBy: EMPID,
        };
        const response = await dispatch(
            PermissionApprovalVerify({
                Type: "L",
                RecordID: recID,
                EmployeeID: Data.EmployeeID,
                ManagerID: params.managerID,
                Status: values.Status,
                Password: values.password,
                ManagerComments: values.managerComments ? values.managerComments : ""
            })
        );
        if (response.payload.Status === "Y") {
            dispatch(mailNotify({
                EmployeeID: Data.EmployeeID,
                ManagerID: params.managerID,
                Reason: "",
                RecordID: recID,
                Source: "M",
                Status: values.Status == "AP" ? "Y" : values.Status == "RJ" ? "N" : "Q",
                Type: "L"
            })
            );
            toast.success(response.payload.Msg);
            navigate(`/approval/notification/L/${values.Status}`);
        } else {
            console.log("🚀 ~ DTSaveFn ~ response.payload.Msg:", response.payload.Msg)
            toast.error(response.payload.Msg);
        }

    };
    const columns = [
        {
            field: "SLNO",
            headerName: "SL#",
            width: 50,
            headerAlign: "center",
            align: "right",
        },

        {
            field: "ManagerName",
            headerName: "Manager",
            width: 200,
            headerAlign: "center",
            align: "left",
        },
        {
            field: "ManagerLevel",
            headerName: "Level",
            width: 50,
            headerAlign: "center",
            align: "left",
        },
        {
            field: "Status",
            headerName: "Status",
            width: 200,
            headerAlign: "center",
            align: "left",
        },
        {
            field: "ApprovalComments",
            headerName: "Comment",
            width: 400,
            headerAlign: "center",
            align: "left",
        },
        {
            field: "ApprovalDate",
            headerName: "Approved Date",
            width: 200,
            headerAlign: "center",
            align: "center",
        },
    ];

    const [rowCount, setRowCount] = useState(0);
    function Custombar() {
        return (
            <GridToolbarContainer
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                }}
            >
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                    <Typography>List of Approvals</Typography>
                    <Typography variant="h5">{`(${rowCount})`}</Typography>
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                    }}
                >
                    <GridToolbarQuickFilter />
                    {/* <Tooltip title="ADD">
            <IconButton onClick={() => selectcelldata("", "A", "")}>
              <AddOutlinedIcon />
            </IconButton>
          </Tooltip> */}
                </Box>
            </GridToolbarContainer>
        );
    }
    // async function fileUpload(file){
    //   console.log("🚀 ~ fileUpload ~ file:", file)
    //    const formData = new FormData();
    //    formData.append('file', file);
    //    formData.append('empId', EMPID);
    //    formData.append('appId', Data.RecordID);
    //    formData.append('type', "L");
    //    console.log("🚀 ~ fileUpload ~ formData:", formData)
    //   const respose = await dispatch(attachmentPost({data:formData}))

    //   if(respose.payload.success){
    //     toast.success(respose.payload.message)
    //   }else{
    //     toast.success(respose.payload.message)
    //   }

    //   console.log("🚀 ~ fileUpload ~ respose:", respose)
    // }
    async function fileUpload(file, EMPID, action, id, purpose) {
        console.log("🚀 ~ fileUpload ~ file:", file)
        const formData = new FormData();
        formData.append('file', file);
        formData.append('empId', Data.EmployeeID);
        formData.append('appId', Data.RecordID);
        formData.append('type', "L");
        formData.append('source', "Self");
        formData.append("action", action);
        formData.append("id", id);
        formData.append("purpose", purpose);
        console.log("🚀 ~ fileUpload ~ formData:", formData)
        const respose = await dispatch(attachmentPost({ data: formData }))

        if (respose.payload.success) {
            toast.success(respose.payload.message)
            //setShowtable(true);
            var url = store.getState().globalurl.empGetAttachmentUrl;
            axios
                .get(url, {
                    params: {
                        empId: Data.EmployeeID,
                        appId: Data.RecordID,

                    }
                })
                .then((response) => {
                    setFiles(response.data);
                })
                .catch((err) => {
                    setError('Failed to fetch attachments.');
                    console.error(err);
                })
                .finally(() => setLoading(false));
        }
        else {
            toast.success(respose.payload.message)
        }

        console.log("🚀 ~ fileUpload ~ respose:", respose)
    }
    return (
        <React.Fragment>
            {getLoading && <LinearProgress />}
            <Paper elevation={3} sx={{ margin: "0px 10px", background: "#F2F0F0" }}>
                <Box display="flex" justifyContent="space-between" p={1}>
                    {/* SEARCH BAR */}
                    <Box
                        display="flex"
                        // backgroundColor={colors.primary[400]}
                        borderRadius="3px"
                        alignItems={"center"}
                    >
                        {/* {broken && !rtl && (
                            <IconButton onClick={() => toggleSidebar()}>
                                <MenuOutlinedIcon />
                            </IconButton>
                        )} */}
                        <Box
                            display={isNonMobile ? "flex" : "none"}
                            borderRadius="3px"
                            alignItems="center"
                        >
                            <Breadcrumbs
                                maxItems={3}
                                aria-label="breadcrumb"
                                separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                            >
                                <Typography
                                    variant="h5"
                                    color="#0000D1"
                                    sx={{ cursor: "default" }}
                                    onClick={() => {
                                        setScreen(0);
                                    }}
                                >
                                    Leave Entry
                                </Typography>

                                {show == "1" ? (
                                    <Typography
                                        variant="h5"
                                        color="#0000D1"
                                        sx={{ cursor: "default" }}
                                    >
                                        Approval Lists
                                    </Typography>
                                ) : (
                                    false
                                )}


                            </Breadcrumbs>
                        </Box>

                    </Box>


                </Box>
            </Paper>

            {show == "0" && !getLoading ? (
                <Paper elevation={3} sx={{ margin: "10px" }}>
                    {mode === "IM" && (
                        <Box
                            display="flex"
                            padding={1}
                            justifyContent="flex-end"
                            mt="2px"
                            gridColumn="span 4"
                            gap={2}
                            marginBottom={-5}
                        >
                            <IconButton
                                onClick={() => setShowImage(prev => !prev)}
                            >
                                <ArrowDownwardIcon sx={{ color: "blue" }} />
                            </IconButton>
                        </Box>)}

                    <Formik
                        initialValues={leaveInitialValue}
                        enableReinitialize={true}
                        validationSchema={validationSchema}
                        onSubmit={(values, { resetForm }) => {
                            setTimeout(() => {
                                leaveFNsave(values, resetForm, false);
                            }, 100);
                        }}
                    >
                        {({
                            errors,
                            touched,
                            handleBlur,
                            handleChange,
                            isSubmitting,
                            values,
                            handleSubmit,
                            resetForm,
                            setFieldValue,
                            setFieldTouched
                        }) => (
                            <form
                                onSubmit={handleSubmit}
                                onReset={() => {
                                    resetForm();
                                }}
                            >
                                <Box
                                    display="grid"
                                    gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                                    gap={formGap}
                                    padding={1}
                                    sx={{
                                        "& > div": {
                                            gridColumn: isNonMobile ? undefined : "span 4",
                                        },
                                    }}
                                >
                                    <FormControl sx={{ gridColumn: "span 2", gap: "15px" }}>
                                        <TextField
                                            name="applieddate"
                                            type="date"
                                            id="applieddate"
                                            label="Applied Date"
                                            variant="standard"
                                            focused
                                            inputFormat="YYYY-MM-DD"
                                            value={values.applieddate}
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            error={!!touched.applieddate && !!errors.applieddate}
                                            helperText={touched.applieddate && errors.applieddate}
                                            sx={{ gridColumn: "span 2" }}
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{
                                                max: new Date().toISOString().split("T")[0],
                                                readOnly: true,
                                            }}
                                        // disabled={
                                        //     mode == "E" &&
                                        //     values.Status != "AL" &&

                                        //     values.Status != "QR"
                                        // }
                                        />
                                        <Productautocomplete
                                            name="leavetype"
                                            label={
                                                <>
                                                    Leave Type<span style={{ color: "red" }}> *</span>
                                                </>
                                            }
                                            id="leavetype"
                                            inputProps={{ readOnly: true }}
                                            value={values.leavetype}
                                            onChange={async (newValue) => {
                                                setFieldValue("leavetype", newValue);
                                                if (newValue?.RecordID) {
                                                    await Balancedayfind(newValue.RecordID);
                                                }
                                            }}
                                            onBlur={() => setFieldTouched("leavetype", true)}
                                            // disabled={
                                            //     mode == "E" &&
                                            //     values.Status != "AL" &&
                                            //     values.Status != "RA" &&
                                            //     values.Status != "QR"
                                            // }

                                            // "Filter":"parentID='${compID}' AND EmployeeID='${EMPID}'" ,
                                            url={`${listViewurl}?data={"Query":{"AccessID":"2107","ScreenName":"Leave Type","Filter":"parentID='${compID}' AND EmployeeID='${EMPID}'","Any":""}}`}
                                        />
                                        {touched.leavetype && errors.leavetype && (
                                            <div style={{ color: "red", fontSize: "12px", marginTop: "-8px" }}>
                                                {errors.leavetype}
                                            </div>
                                        )}
                                        {/* <Productautocomplete
                      name="leavetype"
                      label="Leave Type"
                      id="leavetype"
                      required
                      value={values.leavetype}
                      onChange={async (newValue) => {
                        setFieldValue("leavetype", newValue);
                        if (newValue?.RecordID) {
                          await Balancedayfind(newValue.RecordID);
                        }
                      }}
                      disabled={
                        mode == "E" &&
                        values.Status != "AL" &&
                        values.Status != "RA" &&
                        values.Status != "QR"
                      }
                      error={touched.leavetype && Boolean(errors.leavetype)}
                      helperText={touched.leavetype && errors.leavetype}
                      url={`${listViewurl}?data={"Query":{"AccessID":"2107","ScreenName":"Leave Type","Filter":"parentID='${compID}' AND EmployeeID='${EMPID}'","Any":""}}`}
                    /> */}

                                        {!showImage ? <React.Fragment>
                                            <FormControl
                                                focused
                                                variant="filled"
                                                sx={{ gridColumn: "span 2" }}

                                            >
                                                <InputLabel variant="standard" id="LeavePart">
                                                    {
                                                        <span>
                                                            Leave Part <span style={{ color: "red" }}>*</span>
                                                        </span>
                                                    }
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-filled-label"
                                                    fullWidth
                                                    variant="standard"
                                                    type="text"
                                                    inputProps={{ readOnly: true }}
                                                    value={values.LeavePart}
                                                    id="LeavePart"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    name="LeavePart"
                                                    required
                                                    focused
                                                >
                                                    <MenuItem value="FH">First Half</MenuItem>
                                                    <MenuItem value="SH">Second Half</MenuItem>
                                                    <MenuItem value="N">Full Day</MenuItem>
                                                </Select>
                                            </FormControl>
                                            <TextField

                                                name="FromDate"
                                                type="date"
                                                id="FromDate"
                                                label="From Date"
                                                variant="standard"
                                                inputProps={{ readOnly: true }}
                                                InputLabelProps={{ shrink: true }}
                                                focused
                                                value={values.FromDate}
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                required
                                                sx={{ gridColumn: "span 2" }}
                                            />
                                            <TextField

                                                name="ToDate"
                                                type="date"
                                                id="ToDate"
                                                label="To Date"
                                                variant="standard"
                                                InputLabelProps={{ shrink: true }}
                                                focused
                                                value={values.ToDate}
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                required
                                                sx={{ gridColumn: "span 2" }}
                                                inputProps={{
                                                    min:
                                                        values.FromDate ||
                                                        new Date().toISOString().split("T")[0],
                                                    readOnly: true
                                                }}
                                            />
                                            <TextField
                                                fullWidth
                                                variant="standard"
                                                type="number"
                                                label="Balance Days"
                                                id="BalanceDay"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={selectedLeavetypebalance || values.BalanceDay}
                                                name="BalanceDay"
                                                // disabled={
                                                //     mode == "E" &&
                                                //     values.Status != "AL" &&
                                                //     values.Status != "RA" &&
                                                //     values.Status != "QR"
                                                // }
                                                focused
                                                onWheel={(e) => e.target.blur()}
                                                InputProps={{
                                                    readOnly: true,
                                                    inputProps: {
                                                        style: { textAlign: "right" },
                                                    },
                                                }}
                                            />
                                            <TextField
                                                // disabled={
                                                //     mode == "E" &&
                                                //     values.Status != "AL" &&
                                                //     values.Status != "RA" &&
                                                //     values.Status != "QR"
                                                // }
                                                fullWidth
                                                variant="outlined"
                                                type="text"
                                                label="Comments"
                                                required
                                                multiline
                                                rows={6}
                                                value={values.comments}
                                                id="comments"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                name="comments"
                                                error={!!touched.comments && !!errors.comments}
                                                helperText={touched.comments && errors.comments}
                                                sx={{
                                                    gridColumn: "span 2",
                                                    backgroundColor: "",
                                                    "& .MuiFilledInput-root": {
                                                        backgroundColor: "",
                                                    },
                                                }}
                                                inputProps={{ readOnly: true }}
                                                focused
                                            />



                                            <TextField
                                                // disabled={mode == "E" && values.Status != "AL"}
                                                fullWidth
                                                variant="outlined"
                                                type="text"
                                                label="Manager Comments"
                                                required
                                                multiline
                                                rows={6}
                                                value={values.managerComments}
                                                id="managerComments"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                name="managerComments"
                                                sx={{
                                                    gridColumn: "span 2",
                                                }}
                                                focused
                                            />


                                            <TextField
                                                select
                                                label="Status"
                                                id="Status"
                                                name="Status"
                                                value={values.Status}
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                required
                                                focused
                                                variant="standard"
                                            >

                                                <MenuItem value="AP">
                                                    Approved
                                                </MenuItem>
                                                <MenuItem value="RJ">
                                                    Rejected
                                                </MenuItem>
                                                <MenuItem value="QR">Query</MenuItem>
                                            </TextField>


                                        </React.Fragment> : false}
                                    </FormControl>


                                    <FileListPopup
                                        open={open}
                                        onClose={() => setOpen(false)}

                                        appId={recID}
                                        empId={EMPID}
                                    />
                                </Box>
                                <Box
                                    display="flex"
                                    justifyContent="end"
                                    mt="20px"
                                    gap="20px"
                                    padding={1}
                                    flexDirection={isNonMobile ? "row" : "column"}
                                >
                                    {Data.Status == "AP" && (
                                        <Alert variant="filled" sx={{ mt: 1 }} severity="success">
                                            Your Leave Request has been Approved.
                                        </Alert>
                                    )}

                                    {Data.Status == "RJ" && (
                                        <Alert variant="filled" sx={{ mt: 1 }} severity="error">
                                            Your Leave Request has been Rejected.
                                        </Alert>
                                    )}
                                    {Data.Status == "QR" && (
                                        <Alert variant="filled" sx={{ mt: 1 }} severity="warning">
                                            Your Leave Request has been Queried.
                                        </Alert>
                                    )}
                                    <TextField
                                        required
                                        name="password"
                                        type="password"
                                        id="password"
                                        label="Password"
                                        variant="standard"
                                        focused
                                        value={values.password}
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        fullWidth={isNonMobile ? false : true}
                                        sx={{ gridColumn: "span 2", width: 300 }}
                                        inputProps={{ readOnly: Data.Status == "AP" || Data.Status == "RJ" ? true : false }}
                                    />
                                    <LoadingButton
                                         disabled={Data.Status == "AP" || Data.Status == "RJ"}
                                        color="success"
                                        variant="contained"
                                        type="submit"
                                        loading={isLoading}
                                    >
                                        Submit
                                    </LoadingButton>
                                </Box>
                            </form>
                        )}
                    </Formik>
                </Paper>
            ) : (
                false
            )}


        </React.Fragment>
    );
};

export default LeaveApproval;
